const AREA_COLORS: Record<string, string> = {
  'Cirurgia Geral': '#f97316',
  'Clínica Médica': '#38bdf8',
  'Ginecologia e Obstetrícia': '#ec4899',
  Pediatria: '#10b981',
  'Saúde Coletiva': '#a78bfa',
  'Sem classificação': '#64748b',
};

const FALLBACK_COLORS = [
  '#facc15',
  '#f43f5e',
  '#22d3ee',
  '#a3e635',
  '#c084fc',
  '#fb923c',
  '#2dd4bf',
];

export function normalizeArea(area: string): string {
  return area
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim();
}

const AREA_COLORS_NORMALIZED: Record<string, string> = Object.fromEntries(
  Object.entries(AREA_COLORS).map(([name, color]) => [
    normalizeArea(name),
    color,
  ]),
);

export function byArea(a: string, b: string): number {
  return a.localeCompare(b, 'pt-BR', { sensitivity: 'base' });
}

function hashIndex(value: string): number {
  let hash = 0;
  for (let i = 0; i < value.length; i++) {
    hash = (hash * 31 + value.charCodeAt(i)) | 0;
  }
  return Math.abs(hash);
}

export function areaColor(area: string): string {
  const key = normalizeArea(area);
  return (
    AREA_COLORS_NORMALIZED[key] ??
    FALLBACK_COLORS[hashIndex(key) % FALLBACK_COLORS.length] ??
    '#38bdf8'
  );
}
